import { useTranslation } from 'react-i18next';

/**
 * The top bar's language switch: one button that names the OTHER language in
 * its own script («English» on Arabic pages, «العربية» on English ones), the
 * convention on Saudi sites. It replaced the two-button EN | AR switch to keep
 * the one-row bar inside 1280px in English; the sidebar carries the full
 * العربية | English control.
 */
export default function LanguageToggle({ className = '' }: { className?: string }) {
  const { t, i18n } = useTranslation('nav');
  const current = (i18n.resolvedLanguage || i18n.language || 'ar').startsWith('en') ? 'en' : 'ar';
  const next = current === 'ar' ? 'en' : 'ar';

  return (
    <button
      type="button"
      lang={next}
      dir={next === 'ar' ? 'rtl' : 'ltr'}
      onClick={() => void i18n.changeLanguage(next)}
      className={[
        'inline-flex min-h-[2.75rem] shrink-0 items-center justify-center whitespace-nowrap rounded-md px-2',
        'text-[0.875rem] font-semibold text-[var(--pv-color-primary)] transition-colors duration-200',
        'hover:bg-[rgba(0,77,64,0.06)] dark:text-[#7FD6C3] dark:hover:bg-white/10',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--pv-color-primary)]',
        className,
      ].join(' ')}
    >
      {t(`language.${next}`)}
    </button>
  );
}
